import { FunctionComponent } from 'react';
import { BodyText, Div, Gutter } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

const BankIdVerificationModal: FunctionComponent = () => {
  const { t } = useTranslation('authentication');
  return (
    <Div>
      <BodyText>{t('BankIdVerification.infoText1')}</BodyText>
      <Gutter />
      <BodyText>{t('BankIdVerification.infoText2')}</BodyText>
    </Div>
  );
};

export default BankIdVerificationModal;
